import { verifyOtp } from '../../../data/repositories/authRepository.js';

export const verifyUserOtp = (contactNumber, otp) => verifyOtp(contactNumber, otp);
